const moment = require('moment');
const chargeDescription = require('./charge-description');

const DAY_TERM_PATTERN = /^day(\d+)$/;

const dateDisplayFormat = dateFormat =>
  dateFormat === 'DD/MM/YYYY' ? 'D MMMM, YYYY' : 'MMMM D, YYYY';

const formatPaymentDate = (value, dateFormat) => {
  if (!value) return '';
  const parsed = moment(value, ['YYYY-MM-DD', moment.ISO_8601], true);
  return parsed.isValid() ? parsed.format(dateDisplayFormat(dateFormat)) : '';
};

// The booking deposit stores its payment term as an enum the API can only
// resolve to a date when the term is a number of days before check-in, so the
// term itself is the fallback wording — never the raw `day30` token.
const balanceDueWhen = (dueOn, dueTerm, dateFormat, translate) => {
  const formattedDate = formatPaymentDate(dueOn, dateFormat);
  if (formattedDate) return formattedDate;

  const term = String(dueTerm || '').trim();
  const dayTerm = term.match(DAY_TERM_PATTERN);
  if (dayTerm) {
    return translate(`cx.global.balance_due_days_before_check_in`, {
      days: dayTerm[1]
    });
  }
  if (term === 'check_in_date') {
    return translate(`cx.global.balance_due_at_check_in`);
  }
  if (term === 'manual' || term.startsWith('day')) return '';
  return term;
};

const balanceDueIsInFuture = dueOn => {
  if (!dueOn) return false;
  const parsed = moment(dueOn, ['YYYY-MM-DD', moment.ISO_8601], true);
  return parsed.isValid() && parsed.isAfter(moment(), 'day');
};

const toAmount = value => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const roundToCents = amount => Math.round(amount * 100) / 100;

// The guest-facing money summary shared by the receipt, payment and
// verification pages. Remaining never goes below zero; anything the guest has
// paid beyond the total is reported separately as `overpaid` so a surplus is
// shown as a credit instead of a negative balance.
const guestBalance = booking => {
  const total = roundToCents(toAmount(booking && booking.price_total));
  const paid = roundToCents(toAmount(booking && booking.price_paid));
  const difference = roundToCents(total - paid);
  return {
    total,
    paid,
    remaining: Math.max(0, difference),
    overpaid: Math.max(0, -difference)
  };
};

const paymentMethodDescription = chargeDescription;

module.exports = {
  balanceDueIsInFuture,
  balanceDueWhen,
  formatPaymentDate,
  guestBalance,
  paymentMethodDescription
};
